import { Typography } from "@mui/material"
import { useEffect, useState } from "react"
import useStyles from "./useStyles"
//import { useDispatch } from "react-redux"

import FilterButton from "../../../components/FilterButton/FilterButton"
import InfoIcon from "@mui/icons-material/Info"

//import { SuborganizationAsoc } from "../SuborganizationsAsoc/SuborganizationAsoc"
import { useNavigate, useSearchParams } from "react-router-dom"
//import { getFirmsCustomer } from "../../../redux/actions/clients"
import BreadcrumbsComponent from "../../Declarations/Breadcrumbs/Breadcrumbs"

export default function SearchClient() {
  const classes = useStyles()
  //const dispatch = useDispatch()
  const [searched, setSearched] = useState(false)
  const [searchParams] = useSearchParams()

  const cuitFromUrl = searchParams.get("cuit")
  const navigate = useNavigate()

  useEffect(() => {
    if (searched && cuitFromUrl) {
      navigate(`/ME/clientes/${cuitFromUrl}`, {
        replace: true,
      })
    }
  }, [searched, cuitFromUrl, navigate])

  return (
    <div className={classes.root}>
      <BreadcrumbsComponent />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>Buscar Cliente</Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: "2rem", color: "#00a78f", marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá visualizar los estudios asociados a un cliente.
        </Typography>
      </div>

      <div>
        <div className={classes.boxTable}>
          <Typography
            className={classes.subtitle}
            sx={{ padding: 2, color: "#4B4952" }}
          >
            Haga clic en el botón e ingrese el número de CUIT.
          </Typography>
          <div className={classes.boxSearchBar}>
            <FilterButton
              searchType="firmsCustomer"
              setSearched={setSearched}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
